const RAW_API_URL = process.env.REACT_APP_API_URL as string;
// Ensure HTTPS to avoid CORS preflight redirect blocks when server forces HTTPS
export const API_URL = RAW_API_URL?.startsWith('http://')
  ? RAW_API_URL.replace(/^http:\/\//, 'https://')
  : RAW_API_URL;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;
export const CRIPTO_SECRETKEY = process.env.REACT_APP_CRIPTO_SECRETKEY as string;
export const NIYO_URL = process.env.REACT_APP_NIYO_URL as string
 //export const STRIPE_PUBLIC_KEY = `${process.env.REACT_APP_STRIPE_PUBLIC_KEY}` as string;